import { QueryLayout } from "common/components/Layout/QueryLayout";
import { Title } from "common/components/Title/Title";
import { NavLink } from "react-router-dom";
import { useGetAboutUsQuery } from "services/appApi";
import { FC } from "react";
import { phoneFormat } from "../../../common/utils/helpers";

export const AboutServicePage: FC<{ applicationId: number }> = ({
  applicationId,
}) => {
  const { data, isLoading, error, isFetching } =
    useGetAboutUsQuery(applicationId);

  return (
    <section className="absolute top-0 bottom-0 left-0 right-0 z-10 flex h-full flex-col bg-white py-[20px] px-[15px]">
      <div className="flex justify-between">
        <div>
          <Title>О сервисе</Title>
          <div className="mb-[15px] text-sm text-gray">
            <NavLink to="/">Главная</NavLink> / О сервисе
          </div>
        </div>
        <div className="flex flex-col items-end">
          <div className="mb-[5px] text-sm text-gray">
            Связаться с колл-центром
          </div>
          <a className="text-md font-medium" href={`tel:${data?.support}`}>
            {phoneFormat(data?.support ?? "")}
          </a>
        </div>
      </div>
      <div className="grid gap-[15px] rounded border border-lightWhiteGray p-[15px] leading-[17px] text-lightGray">
        <QueryLayout
          isLoading={isLoading}
          isFetching={isFetching}
          error={error}
        >
          <p>{data?.content}</p>
        </QueryLayout>
      </div>
    </section>
  );
};
